import { render, staticRenderFns } from "./exchange-list.vue?vue&type=template&id=6387974e&"
import script from "./exchange-list.vue?vue&type=script&lang=js&"
export * from "./exchange-list.vue?vue&type=script&lang=js&"
import style0 from "./exchange-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "exchange-list.vue"
export default component.exports